"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 300px;\n  margin-top: -50px;\n  margin-left: ", "px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ScrollToResults = _styledComponents.default.div.attrs(function (props) {
  var opacity = props.opacity,
      fixed = props.fixed;
  return {
    style: {
      opacity: opacity,
      visibility: opacity <= 0 ? 'hidden' : 'visible',
      position: fixed ? 'fixed' : 'absolute',
      top: fixed ? '50%' : 'inherit',
      bottom: fixed ? 'inherit' : window.innerHeight / 2 + "px"
    }
  };
}).withConfig({
  displayName: "ScrollToResults",
  componentId: "sc-1b8fba-0"
})(_templateObject(), function (props) {
  return props.containerWidth / 2 - 150;
});

ScrollToResults.propTypes = {
  containerWidth: _propTypes.default.number.isRequired,
  fixed: _propTypes.default.bool,
  opacity: _propTypes.default.number.isRequired
};
var _default = ScrollToResults;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ScrollToResults.js
// module id = 905
// module chunks = 209 210 211 212